import { render } from "./WorkSpaceList.vue?vue&type=template&id=005f39ab"
import script from "./WorkSpaceList.vue?vue&type=script&lang=js"
export * from "./WorkSpaceList.vue?vue&type=script&lang=js"

import "./WorkSpaceList.vue?vue&type=style&index=0&id=005f39ab&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__